import React from "react";

import ReactTooltip from "react-tooltip";
import filterIcon from "../../assets/filter.svg";
import "./Filter.scss";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilterDialog: false,
      categories: {
        "Document Type": {
          Legal: ["Legal 1", "Legal 2", "Legal 3"],
          Contract: ["Company Contracts", "Legal Contracts", "Label 2.3"],
          "Real Estate Folder": [
            "Real Estate 1",
            "Real Estate 2",
            "Real Estate 3",
          ],
          "Personal Folder": ["Personal 1", "Personal 2", "Personal 3"],
          "Software License": ["Development Software"],
        },
        Folder: {
          Legal: ["L1"],
          Contract: ["Company Contracts", "Legal Contracts", "Label 2.3"],
          "Real Estate Folder": ["R1"],
          "Personal Folder": ["P1"],
          "Software License": ["Development Software"],
        },
        Users: [
          "Mike Goodman",
          "Jack Cole",
          "Andrew Shaw",
          "John Paul",
          "Tyler Mason",
          "Harvey Ford",
          "Henry Ford",
          "Darlene Robertson",
          "Jacob Jones",
        ],
        Dates: [
          "Termination",
          "Execution",
          "Start Date",
          "End Date",
          "Invoice Date",
          "Invoice Due Date",
        ],
      },
      selectedCategory: "Document Type",
      filteredCategories: {},
      previouslyFilteredCategories: {},
      searchValue: "",
      subCategorySearchValue: "",
      searchBasedSubCategories: {},
      isFilterApplied: false,
      selectFilterValue: "",
      filterMessage: false,
      fieldData: {},
    };

    this.filterRef = React.createRef();
    this.handleClickOutsideOfFilter =
      this.handleClickOutsideOfFilter.bind(this);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutsideOfFilter);
  }

  handleClickOutsideOfFilter(event) {
    if (
      this.filterRef &&
      this.filterRef.current &&
      !this.filterRef.current.contains(event.target)
    ) {
      this.setState({ showFilterDialog: false });
    }
  }

  addFieldCategories = (abstractJson) => {
    let fieldCategories = {};
    abstractJson.map((tab) => {
      tab["tabSections"].map((section) => {
        section["sectionFields"].map((field) => {
          // fieldCategories[field["fieldLabel"]] = []
          if (
            field["inputType"] === "Radio" ||
            field["inputType"] === "Checkbox" ||
            field["inputType"] === "Dropdown"
          ) {
            fieldCategories[field["fieldLabel"]] = [];
            field["options"].map((option) => {
              fieldCategories[field["fieldLabel"]].push(option["optionValue"]);
              return true;
            });
          } else if (
            field["inputType"] === "Date" ||
            field["inputType"] === "Number"
          ) {
            fieldCategories[field["fieldLabel"]] = {};
            fieldCategories[field["fieldLabel"]]["inputType"] =
              field["inputType"];
          } else if (
            field["inputType"] === "TextField" ||
            field["inputType"] === "TextArea"
          ) {
            fieldCategories[field["fieldLabel"]] = {};
            fieldCategories[field["fieldLabel"]]["inputType"] =
              field["inputType"];
          }
          return true;
        });
        return true;
      });
      return true;
    });
    return fieldCategories;
  };

  filterCategories = () => {
    if (this.props.isFoldersView) {
      const categories = {
        Folder: [],
      };
      this.props.subfolders.map((subfolder) => {
        return categories.Folder.push(subfolder.title);
      });
      this.setState({
        categories: categories,
        selectedCategory: Object.keys(categories)[0],
      });
    } else if (this.props.isDocumentView) {
      let categories = {
        "Document Type": [],
      };
      this.props.loadDocuments.map((document) => {
        const title = document.documentType.title;
        if (!categories["Document Type"].includes(title)) {
          categories["Document Type"].push(title);
        }
        let fieldCategories = this.addFieldCategories(
          document["abstractJson"].filter(json => json.tabTitle !== "Overview")
        );
        categories = { ...categories, ...fieldCategories };
        return true;
      });
      this.setState({
        categories: categories,
        selectedCategory: Object.keys(categories)[0],
      });
    } else if (this.props.calendarView) {
      const categories = {
        "Document Type": this.props.documentTypes,
        Folder: {},
        Dates: this.props.dateTitles,
      };

      // set folders and subfolders
      const rootFolders = [...this.props.rootFolders];
      const subFolders = { ...this.props.subFolders };
      rootFolders.map((rootFolder) => {
        const titleArr = [];
        const subFolderArr = subFolders[rootFolder.id] || [];
        subFolderArr.map((subFolder) => titleArr.push(subFolder.title));
        categories.Folder[rootFolder.title] = titleArr;
        return true;
      });
      this.setState({
        categories: categories,
        selectedCategory: Object.keys(categories)[0],
      });
    } else if (this.props.isUserView) {
      this.setState({
        categories: this.props.categories,
        selectedCategory: Object.keys(this.props.categories)[0],
      });
    } else if (
      this.props.isArchivedView &&
      (this.props.isSubFolderArchive || this.props.isDocumentArchive)
    ) {
      if (this.props.isDocumentArchive) {
        let categories = {
          "Document Type": [],
        };

        this.props.documents.map((document) => {
          const title = document.documentType.title;
          if (!categories["Document Type"].includes(title)) {
            categories["Document Type"].push(title);
            let fieldCategories = this.addFieldCategories(
              document["abstractJson"].filter(json => json.tabTitle !== "Overview")
            );
            categories = { ...categories, ...fieldCategories };
          }
          return true;
        });
        this.setState({
          categories: categories,
          selectedCategory: Object.keys(categories)[0],
        });
      } else {
        this.setState({
          categories: this.props.categories,
          selectedCategory: Object.keys(this.props.categories)[0],
        });
      }
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutsideOfFilter);
    this.filterCategories();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.filterCategories();
    }
  }

  openFilterDialog = () => {
    let isOpen = !this.state.showFilterDialog;
    if (isOpen) {
      this.setState({ showFilterDialog: isOpen });
    } else {
      this.cancelOnClickHandler();
    }
  };

  categoryOnClickHandler = (category) => {
    this.setState({
      selectedCategory: category,
      searchValue: "",
      searchBasedSubCategories: {},
    });
  };

  handleCheckboxSelection = (
    e,
    category,
    subCategory,
    categoryItem = undefined,
    fromList = false
  ) => {
    const isChecked = e.target.checked;

    if (fromList) {
      // From list
      if (isChecked) {
        // Add item to the filteredCategories list
        if (category in this.state.filteredCategories) {
          this.setState((prevState) => ({
            filteredCategories: {
              ...prevState.filteredCategories,
              [category]: [
                ...prevState.filteredCategories[category],
                subCategory,
              ],
            },
          }));
        } else {
          this.setState((prevState) => ({
            filteredCategories: {
              ...prevState.filteredCategories,
              [category]: [subCategory],
            },
          }));
        }
      } else {
        // Remove item from the filteredCategories list
        let newList = [...this.state.filteredCategories[category]];
        newList.splice(newList.indexOf(subCategory), 1);

        if (newList.length === 0) {
          let newState = this.state.filteredCategories;
          delete newState[category];
          this.setState({ filteredCategories: newState });
        } else {
          this.setState((prevState) => ({
            filteredCategories: {
              ...prevState.filteredCategories,
              [category]: newList,
            },
          }));
        }
      }
    } else {
      // From accordion

      if (categoryItem === undefined) {
        // Accordion item checked/unchecked
        if (isChecked) {
          this.setState((prevState) => ({
            filteredCategories: {
              ...prevState.filteredCategories,
              [category]: {
                ...prevState.filteredCategories[category],
                [subCategory]: prevState.categories[category][subCategory],
              },
            },
          }));
        } else {
          let newState = this.state.filteredCategories[category];
          delete newState[subCategory];
          if (Object.keys(newState).length > 0) {
            this.setState((prevState) => ({
              filteredCategories: {
                ...prevState.filteredCategories,
                [category]: newState,
              },
            }));
          } else {
            newState = this.state.filteredCategories;
            delete newState[category];
            this.setState({ filteredCategories: newState });
          }
        }
      } else {
        // Child of accordion item checked/unchecked
        if (isChecked) {
          if (category in this.state.filteredCategories) {
            if (subCategory in this.state.filteredCategories[category]) {
              this.setState((prevState) => ({
                filteredCategories: {
                  ...prevState.filteredCategories,
                  [category]: {
                    ...prevState.filteredCategories[category],
                    [subCategory]: [
                      ...prevState.filteredCategories[category][subCategory],
                      categoryItem,
                    ],
                  },
                },
              }));
            } else {
              this.setState((prevState) => ({
                filteredCategories: {
                  ...prevState.filteredCategories,
                  [category]: {
                    ...prevState.filteredCategories[category],
                    [subCategory]: [categoryItem],
                  },
                },
              }));
            }
          } else {
            this.setState((prevState) => ({
              filteredCategories: {
                ...prevState.filteredCategories,
                [category]: {
                  ...prevState.filteredCategories[category],
                  [subCategory]: [categoryItem],
                },
              },
            }));
          }
        } else {
          let newList = [
            ...this.state.filteredCategories[category][subCategory],
          ];
          newList.splice(newList.indexOf(categoryItem), 1);

          if (newList.length === 0) {
            let newState = this.state.filteredCategories[category];
            delete newState[subCategory];

            if (Object.keys(newState).length > 0) {
              this.setState((prevState) => ({
                filteredCategories: {
                  ...prevState.filteredCategories,
                  [category]: newState,
                },
              }));
            } else {
              newState = this.state.filteredCategories;
              delete newState[category];
              this.setState({ filteredCategories: newState });
            }
          } else {
            this.setState((prevState) => ({
              filteredCategories: {
                ...prevState.filteredCategories,
                [category]: {
                  ...prevState.filteredCategories[category],
                  [subCategory]: newList,
                },
              },
            }));
          }
        }
      }
    }
  };

  handleSeletAllSubcategory = (category, checked) => {

    this.setState((prevState) => {
      let filteredCategories = { ...prevState.filteredCategories };
      if(checked) {
        filteredCategories[category] = [...this.state.categories[category]]
      } else {
        delete filteredCategories[category]
      }
      return {
        filteredCategories: filteredCategories,
      };
    });
  }

  getFilterCategories = () => {
    const getCategoryCount = (category) => {
      let counter = 0;
      let filteredCategories = this.state.filteredCategories;
      let selectedCategory = this.state.filteredCategories[category];
      if (category in filteredCategories) {
        if (!Array.isArray(selectedCategory)) {
          if (
            Array.isArray(
              selectedCategory[Object.keys(filteredCategories[category])[0]]
            )
          ) {
            Object.keys(filteredCategories[category]).map(
              (subCategory) =>
                (counter += filteredCategories[category][subCategory].length)
            );
          } else {
            counter = 1;
          }
        } else {
          // List
          counter = filteredCategories[category].length;
        }
      }
      return counter ? counter : "";
    };

    let filters = Object.keys(this.state.categories);
    if (this.state.searchValue.length > 0) {
      filters = this.state.searchBasedSubCategories;
      // this.setState({
      //   selectedCategory : Object.keys(filters)[0]
      // })
    }
    return filters.map((category, index) => (
      <div
        className={`category${
          this.state.selectedCategory === category ? " selected" : ""
        }`}
        onClick={() => {
          this.categoryOnClickHandler(category);
        }}
        key={index}
      >
        <p className="category-title">
          {category === "Folder" ? "Sub-folders" : category}
        </p>
        {getCategoryCount(category) ? (
          <p className="category-count">
            {getCategoryCount(category)}
          </p>
        ) : null}
      </div>
    ));
  };

  updateSubcategoryObject = (keyValue, subCategory, category, objectKey) => {
    subCategory[objectKey] = keyValue;
    // Add item to the filteredCategories list
    if (category in this.state.filteredCategories) {
      this.setState((prevState) => ({
        filteredCategories: {
          ...prevState.filteredCategories,
          [category]:
            // ...prevState.filteredCategories[category],
            subCategory,
        },
      }));
    } else {
      this.setState((prevState) => ({
        filteredCategories: {
          ...prevState.filteredCategories,
          [category]: subCategory,
        },
      }));
    }
  };

  addDateFieldFilter = (e, subCategory, category) => {
    subCategory[e.target.name] = e.target.value;
    if (category in this.state.filteredCategories) {
      this.setState((prevState) => ({
        filteredCategories: {
          ...prevState.filteredCategories,
          [category]:
            // ...prevState.filteredCategories[category],
            subCategory,
        },
      }));
    } else {
      this.setState((prevState) => ({
        filteredCategories: {
          ...prevState.filteredCategories,
          [category]: subCategory,
        },
      }));
    }
  };

  getTextfieldValue = (e, subCategory, category) => {
    var filterdText = document.getElementById(e.target.id).previousSibling
      .value;
    this.updateSubcategoryObject(filterdText, subCategory, category, "value");
  };

  addDateNumberFilter = (e, subCategory, category) => {
    let keyMapping = { 0: "filter", 1: "fieldValue1", 2: "fieldValue2" };
    var siblingValue = [];
    var elem = document.getElementById(e.target.id).parentNode.firstChild;
    while (elem.nextSibling) {
      siblingValue.push(elem.value);
      elem = elem.nextSibling;
    }
    siblingValue = siblingValue.slice(1);
    if (siblingValue.length < 1) {
      this.setState({
        filterMessage: true,
      });
    }
    siblingValue.map((value, index) => {
      this.updateSubcategoryObject(
        value,
        subCategory,
        category,
        keyMapping[index]
      );
      return true;
    });
  };

  saveFieldValues = (e, category, key) => {
    let inputValue = e.target.value;
    let fieldData = this.state.fieldData;
    if (!fieldData[category]) {
      fieldData[category] = {};
    }
    fieldData[category][key] = inputValue;
    this.setState({ fieldData: fieldData });
  };

  createAccordion = (subCategory, category) => {
    if (Array.isArray(Object.values(subCategory)[0])) {
      let data = subCategory;

      const isChecked = (category, subCategory, categoryItem) => {
        if (category in this.state.filteredCategories) {
          if (subCategory in this.state.filteredCategories[category]) {
            return (
              this.state.filteredCategories[category][subCategory].indexOf(
                categoryItem
              ) !== -1
            );
          }
        }
        return false;
      };

      const isAccordionChecked = (category, subCategory) => {
        if (category in this.state.filteredCategories) {
          if (subCategory in this.state.filteredCategories[category]) {
            return (
              this.state.filteredCategories[category][subCategory].length ===
              this.state.categories[category][subCategory].length
            );
          }
        }
        return false;
      };

      const hasAnyCheckedItem = (category, subCategory) => {
        if (category in this.state.filteredCategories) {
          if (subCategory in this.state.filteredCategories[category]) {
            return (
              this.state.filteredCategories[category][subCategory].length > 0
            );
          }
        }
        return false;
      };

      return Object.keys(data).length > 0 ? (
        Object.keys(data).map((subCategory, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-label="Expand"
              aria-controls="additional-actions1-content"
              id="additional-actions1-header"
            >
              <FormControlLabel
                aria-label="Acknowledge"
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                control={
                  <Checkbox
                    checked={isAccordionChecked(category, subCategory)}
                    onChange={(e) =>
                      this.handleCheckboxSelection(e, category, subCategory)
                    }
                    disableRipple
                    className="accordion-checkbox"
                    size="small"
                  />
                }
                label={subCategory}
                id={
                  hasAnyCheckedItem(category, subCategory)
                    ? "has-checked-items"
                    : ""
                }
              />
            </AccordionSummary>
            <AccordionDetails>
              {data[subCategory].map((categoryItem, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={isChecked(category, subCategory, categoryItem)}
                      onChange={(e) =>
                        this.handleCheckboxSelection(
                          e,
                          category,
                          subCategory,
                          categoryItem
                        )
                      }
                      disableRipple
                      className="accordion-checkbox"
                      size="small"
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label={categoryItem}
                />
              ))}
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <p className="text-center mt-2">No results found!</p>
      );
    } else {
      let columns = {
        Date: ["On", "Before", "After", "Between", "Is blank"],
        Number: [
          "Is equal",
          "Does not equal",
          "Is less than",
          "Is greater than",
          "Is blank",
        ],
      };

      if (
        subCategory["inputType"] === "TextField" ||
        subCategory["inputType"] === "TextArea"
      ) {
        return (
          <div className="d-flex flex-column align-items-center m-12">
            <input
              type="text"
              maxLength="300"
              id={category}
              placeholder="Enter text to filter"
              value={
                this.state.fieldData[category]
                  ? this.state.fieldData[category]["value"]
                  : ""
              }
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  this.updateSubcategoryObject(
                    e.target.value,
                    subCategory,
                    category,
                    "value"
                  );
                }
              }}
              onChange={(e) => this.saveFieldValues(e, category, "value")}
            />
            <button
              className="btn-primary mt-4"
              id={[category, Math.floor(Math.random() * 100)].join("")}
              onClick={(e) =>
                this.getTextfieldValue(
                  e,
                  subCategory,
                  category,
                  subCategory["inputType"]
                )
              }
            >
              Add Filter
            </button>
          </div>
        );
      } else {
        return (
          <div className="d-flex flex-column align-items-center m-12">
            <p style={{ fontSize: "16px" }}>
              {category}{" "}
              {this.state.fieldData[category] &&
              this.state.fieldData[category]["filter"]
                ? this.state.fieldData[category]["filter"]
                : null}
            </p>
            <select
              className="w-75"
              id={category}
              onChange={(e) => {
                this.setState({ selectFilterValue: e.target.value });
                this.saveFieldValues(e, category, "filter");
              }}
            >
              <option
                value=""
                disabled
                selected={!this.state.fieldData[category] ? true : false}
              >
                select..
              </option>
              {columns[subCategory["inputType"]].map((item, index) => (
                <option
                  value={item}
                  selected={
                    this.state.fieldData[category] &&
                    this.state.fieldData[category]["filter"] === item
                      ? true
                      : false
                  }
                >
                  {item}
                </option>
              ))}
            </select>

            {subCategory["inputType"] === "Date" ? (
              <input
                class="form-control w-80"
                name="selectDate1"
                type="date"
                style={{ marginTop: "1rem" }}
                value={
                  this.state.fieldData[category]
                    ? this.state.fieldData[category]["fieldValue1"]
                    : ""
                }
                onChange={(e) =>
                  this.saveFieldValues(e, category, "fieldValue1")
                }
              ></input>
            ) : null}

            {this.state.fieldData[category] &&
            this.state.fieldData[category]["filter"] === "Between" ? (
              <input
                class="form-control w-80"
                name="selectDate2"
                type="date"
                style={{ marginTop: "1rem" }}
                onChange={(e) =>
                  this.saveFieldValues(e, category, "fieldValue2")
                }
                value={
                  this.state.fieldData[category]
                    ? this.state.fieldData[category]["fieldValue2"]
                    : ""
                }
              ></input>
            ) : null}

            {subCategory["inputType"] === "Number" ? (
              <input
                name="selectNumber"
                className="w-75"
                type="number"
                style={{ marginTop: "1rem" }}
                value={
                  this.state.fieldData[category]
                    ? this.state.fieldData[category]["fieldValue1"]
                    : null
                }
                onChange={(e) =>
                  this.saveFieldValues(e, category, "fieldValue1")
                }
              ></input>
            ) : null}
            {this.state.filterMessage ? (
              <p className="error">please select all fields</p>
            ) : null}
            <button
              className="btn-primary mt-4"
              id={[category, Math.floor(Math.random() * 1000)].join("")}
              onClick={(e) =>
                this.addDateNumberFilter(e, subCategory, category)
              }
            >
              Add Filter
            </button>
          </div>
        );
      }
    }
  };

  createList = (dataList, category) => {
    const isChecked = (category, item) => {
      if (category in this.state.filteredCategories) {
        return this.state.filteredCategories[category].indexOf(item) !== -1;
      }
      return false;
    };

    let isSelectAll = false
    if(Array.isArray(this.state.filteredCategories[category])) {
      isSelectAll = this.state.filteredCategories[category].length === this.state.categories[category].length
    }

    let isIndeterminate = false
    if(Array.isArray(this.state.filteredCategories[category])) {
      isIndeterminate = this.state.filteredCategories[category].length !== 0 && this.state.filteredCategories[category].length !== this.state.categories[category].length
    }

    const filteredDataList = dataList.filter((item) => item.includes(this.state.subCategorySearchValue.trim()));
    // console.log(this.state.categories[category]);
    // const isSelectAll = this.state.filteredCategories[category].filter((subcat) => console.log(subcat))
    // dataList[activeCategory].tempFilterCount === category.options.length

    return (
      <>
        <div className="search-sub-category">
          <div className="search-box">
            <input
              type="text"
              maxLength="300"
              placeholder={`Search ${category}`}
              onChange={this.subCategorySearchTextChangeHandler}
              value={this.state.subCategorySearchValue}
            />
          </div>
          <div className="select-all">
            <FormControlLabel
              aria-label="Select All"
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
              control={
                <Checkbox
                  checked={isSelectAll}
                  onChange={(e) => this.handleSeletAllSubcategory(category, e.target.checked)}
                  // disableRipple={true}
                  className="accordion-checkbox"
                  size="small"
                  indeterminate={isIndeterminate}
                />
              }
              label="Select All"
            />
          </div>
        </div>
        <div className="sub-categories-options">
          {filteredDataList.length > 0 ? (
            filteredDataList.map((item, index) => (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={isChecked(category, item)}
                    onChange={(e) => this.handleCheckboxSelection(e, category, item, undefined, true)}
                    disableRipple
                    className="accordion-checkbox"
                    size="small"
                    name="checkedB"
                    color="primary"
                  />
                }
                label={item}
              />
            ))
          ) : (
            <p className="text-center mt-2">No results found!</p>
          )}
        </div>
      </>
    );
  };

  getFilterSubCategories = () => {
    let categories = Object.keys(this.state.categories);

    for (let index = 0; index < categories.length; index++) {
      const category = categories[index];

      if (category === this.state.selectedCategory) {
        let subCategory = this.state.categories[category];

        if (!Array.isArray(subCategory)) {
          // Accordion
          return (
            <div className="accordion-list">
              {this.createAccordion(subCategory, category)}
            </div>
          );
        } else {
          // Simple List
          return (
            <div className="item-list">
              {this.createList(subCategory, category)}
            </div>
          );
        }
      }
    }
  };

  clearAllFilters = (e) => {
    e.preventDefault();
    this.setState({
      filteredCategories: {},
      searchValue: "",
      searchBasedSubCategories: {},
      fieldData: {},
    });
  };

  searchTextChangeHandler = (e) => {
    let searchText = e.target.value;
    this.setState({ searchValue: searchText });
    if (searchText.length > 0) {
      searchText = searchText.toLowerCase();
      let searchBasedSubCategories = {};
      const targetData = Object.keys(this.state.categories);
      searchBasedSubCategories = targetData.filter((item) =>
        item.toLowerCase().includes(searchText)
      );

      this.setState({
        searchBasedSubCategories: searchBasedSubCategories,
        selectedCategory: searchBasedSubCategories[0],
      });
    } else {
      this.setState({ searchBasedSubCategories: {} });
    }
  };

  subCategorySearchTextChangeHandler = (e) => {
    let searchText = e.target.value;
    this.setState({ subCategorySearchValue: searchText });
  }

  cancelOnClickHandler = () => {
    this.setState({
      showFilterDialog: false,
      filteredCategories: JSON.parse(
        JSON.stringify(this.state.previouslyFilteredCategories)
      ),
    });
  };

  applyOnClickHandler = () => {
    // Do something according to the business logic
    this.setState({
      isFilterApplied: true,
      showFilterDialog: false,
      previouslyFilteredCategories: JSON.parse(
        JSON.stringify(this.state.filteredCategories)
      ),
    });
    this.props.filterApplyHandler(this.state.filteredCategories);
  };

  render() {
    return (
      <div className="filter-component" ref={this.filterRef}>
        <ReactTooltip id="filterTip" place="top" effect="solid">
          Filters
        </ReactTooltip>
        <button
          className={`btn-dropdown d-flex filter-button mr-4 ${this.state.showFilterDialog ? "active" : ""}`}
          onClick={this.openFilterDialog}
        >
          <div className="text-auto-primary">
            <span
              className={
                Object.keys(this.state.previouslyFilteredCategories).length > 0 && this.state.isFilterApplied
                  ? "filter-applied"
                  : "no-filter"
              }
            >
              <img src={filterIcon} alt="filter" />
            </span>
          </div>
          <div className="text-auto-secondary" data-tip data-for="filterTip">
            <div
              className={
                Object.keys(this.state.previouslyFilteredCategories).length > 0 && this.state.isFilterApplied
                  ? "filter-applied"
                  : "no-filter"
              }
            >
              <img src={filterIcon} alt="filter" />
            </div>
          </div>
        </button>
        {this.state.showFilterDialog ? (
          <div
            className={`filter-container ${
              !this.props.isDocumentView && !this.props.isFoldersView && !this.props.isUserView ? "open-in-left" : "open-in-right"
            } ${this.state.showFilterDialog ? "show" : "hide"}`}
          >
            <div className="filter-header">
              <p className="title">Filters</p>
            </div>

            <div className="filter-body">
              <div className="left">
                <div className="seach-category">
                  <div className="search-box">
                    <input
                      type="text"
                      maxLength="300"
                      placeholder="Search category"
                      onChange={this.searchTextChangeHandler}
                      value={this.state.searchValue}
                    />
                  </div>
                </div>
                <div className="categories">{this.getFilterCategories()}</div>
              </div>
              <div className="sub-categories">{this.getFilterSubCategories()}</div>
            </div>

            <div className="filter-footer">
              <div onClick={this.clearAllFilters} className="clear-all">
                Clear all
              </div>
              <div className="action-buttons">
                <button className="btn-secondary" onClick={this.cancelOnClickHandler}>
                  Cancel
                </button>
                <button className="btn-primary" onClick={this.applyOnClickHandler}>
                  Apply
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
